module.exports = __webpack_public_path__ + "img/gangtieshengchan.9e429a44.jpg";